import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { SaveForm } from '@tokeet/tv3-platform'
import { CustomValidators } from 'ngx-custom-validators'

@Component({
  templateUrl: './close-account-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./close-account-dialog.component.scss'],
})
export class CloseAccountDialogComponent {
  form = this.fb.group({
    reason: ['', [Validators.required]],
    channel_manager: [''],
    email: ['', [CustomValidators.email]],
  })

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CloseAccountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { app: string; callScheduleUrl: string }
  ) {}

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  save(form: FormGroup) {
    this.dialogRef.close({ ...form.getRawValue(), app: this.data.app })
  }
}
